export default __webpack_public_path__ + "static/media/carEX.ab900f35.jpg";